<template>
    <c-modal :value="isOpen" title="Edit Image Effect" @ok="handleClose" @closed="handleClose">
        <form class="space-y-4" @submit.prevent="handleSave">
            <component
                :is="currentEffectComponent"
                v-if="currentEffectComponent"
                :image-effect="formData"
                @update:image-effect="formData = $event"
            />
        </form>
        <template #modal-footer>
            <div>
                <c-button text="Cancel" variant="secondary" @click="handleClose" />
            </div>
            <div>
                <c-button text="Save" variant="primary" @click="handleSave" />
            </div>
        </template>
    </c-modal>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue';
import CModal from '@/components/CModal.vue';
import CButton from '@/components/shared/CButton';

import { EffectType, ImageEffectType } from '@/typings/customilyElements/imageEffectType';
import { getEffectComponent } from '@/components/DesignStudio/ImageEffectsProperties/utils/componentMapper';

const props = defineProps<{
    item: ImageEffectType;
    isOpen: boolean;
}>();

const emit = defineEmits<{
    (event: 'update', value: ImageEffectType): void;
    (event: 'close'): void;
}>();

const formData = ref<ImageEffectType | undefined>(undefined);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const currentEffectComponent = ref<any>(null);

const loadEffectComponent = async (effectType: EffectType) => {
    try {
        currentEffectComponent.value = await getEffectComponent(effectType);
    } catch (error) {
        console.error('Error loading effect component:', error);
        currentEffectComponent.value = null;
    }
};

const resetForm = () => {
    currentEffectComponent.value = null;
};

const handleClose = () => {
    resetForm();
    emit('close');
};

const handleSave = () => {
    if (!formData.value) return;
    emit('update', formData.value);
    handleClose();
};

watch(
    () => props.isOpen,
    () => {
        if (props.isOpen) {
            if (props.item) {
                formData.value = { ...props.item };
                loadEffectComponent(props.item.type);
            }
        }
    }
);
</script>
